import React from "react";
import { Box, Typography, Stack, alpha, useTheme } from "@mui/material";
import { Layers, Shield } from "@mui/icons-material";

const TankCoatingTable = ({ coatingType = "Epoxy" }) => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 1 }}>
      <Stack spacing={2}>
        {/* Sektions-header */}
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: 1.5,
              bgcolor: alpha(theme.palette.warning.main, 0.1),
              color: "warning.main",
              display: "flex",
            }}
          >
            <Layers sx={{ fontSize: 18 }} />
          </Box>
          <Typography
            variant="subtitle2"
            fontWeight="900"
            sx={{ letterSpacing: 0.5 }}
          >
            VESSEL COATING
          </Typography>
        </Stack>

        {/* Coating Display Card */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2.5,
            borderRadius: 3,
            bgcolor: alpha(theme.palette.warning.main, 0.03),
            border: "1px solid",
            borderColor: alpha(theme.palette.warning.main, 0.15),
          }}
        >
          <Box>
            <Typography
              variant="caption"
              color="text.disabled"
              fontWeight="900"
              sx={{ display: "block", mb: 0.5 }}
            >
              PROTECTION TYPE
            </Typography>
            <Typography variant="h6" fontWeight="900" color="text.primary">
              {coatingType.toUpperCase()}
            </Typography>
          </Box>

          <Shield
            sx={{
              fontSize: 40,
              color: "warning.main",
              opacity: 0.2,
            }}
          />
        </Box>

        <Typography
          variant="caption"
          sx={{ color: "text.disabled", fontStyle: "italic", px: 1 }}
        >
          * Coating verified as per ship's technical specifications.
        </Typography>
      </Stack>
    </Box>
  );
};

export default TankCoatingTable;
